module.exports = __webpack_public_path__ + "img/13_mark_d.1b6a30b3.png";